/**
 * Cookie key for tracking AI feature availability
 */
const AI_DISABLED_COOKIE = 'pcl_ai_disabled_v2'
const AI_DISABLE_DURATION_SECONDS = 24 * 60 * 60

/**
 * Checks if the user has the cookie to disable AI
 * @returns true if AI features should be disabled
 */
export function isAiDisabled(): boolean {
  if (typeof document === 'undefined') {
    return false // SSR - assume enabled
  }

  return document.cookie.includes(`${AI_DISABLED_COOKIE}=true`)
}

/**
 * Disables AI features for this user by setting a cookie
 */
export function disableAiFeatures(): void {
  if (typeof document === 'undefined') {
    return
  }

  // Keep the circuit breaker short enough that a transient failure does not
  // hide AI features for multiple days.
  const expiryDate = new Date()
  expiryDate.setSeconds(expiryDate.getSeconds() + AI_DISABLE_DURATION_SECONDS)

  // Only add Secure flag in production (https://)
  const isProduction = window.location.protocol === 'https:'
  const secureFlag = isProduction ? '; Secure' : ''

  document.cookie = `${AI_DISABLED_COOKIE}=true; expires=${expiryDate.toUTCString()}; Max-Age=${AI_DISABLE_DURATION_SECONDS}; path=/; SameSite=Lax${secureFlag}`

  process.env.NODE_ENV === 'development' &&
    console.warn('AI features have been disabled due to an error.')
}
